import LoginImg from "../../assets/images/login-img.png"
import Logo from '../../assets/images/logo.svg';
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { HiOutlineEnvelope } from "react-icons/hi2";
import { HiOutlineKey } from "react-icons/hi2";
import "./login.scss";
import { Modal, Button, Form, Row, Col, Input, Spinner } from 'reactstrap';
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WebService from "../../Services/WebService";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
const SetPassword = () => {
    const {
        register,
        reset,
        watch,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({ mode: "onChange" });
    const [password, setPassword] = useState("");
    const [type, setType] = useState('password');
    const [icon, setIcon] = useState<any>(BsEyeSlash);
    const [showLoader, setShowLoader] = useState<any>(false);
    const [error, setError] = useState<any>(false);
    const [loading, setLoading] = useState<any>(false);
    const [passwordShow, setPasswordShow] = useState<any>(false);
    const history = useNavigate();
    const location = useLocation();
    const email = location.state?.email;

    const handleToggle = () => {
        if (type === 'password') {
            setIcon(BsEye);
            setType('text')
        } else {
            setIcon(BsEyeSlash)
            setType('password')
        }
    }
    const onSave = (data: any) => {
        setLoading(true);
        const { password } = data;
        const token = localStorage.getItem("authToken");
        if (!token) {
            toast.error("Token is missing.");
            setLoading(false);
            return;
        }
        let obj = { password, token };

        WebService.postAPI({
            action: `/set-password`,
            body: obj,
        })
            .then((res: any) => {
                toast.success(res.message);

                history("/login");

                setLoading(false);
            })
            .catch(() => {
                setError(true);
                setLoading(false);
            });
    };

    return (
        <>
            <div className="login-page">
                <div className="row justify-content-center min-vh-100 align-items-center mx-0">

                    <div className="col-lg-5 d-flex align-items-center justify-content-center">
                        <div className="w-75 login-card rounded-4">
                            <div className="px-lg-5 px-3 py-5">
                                <div className="text-center  mb-4">
                                    <img src={Logo} width="100" alt="Logo" />
                                </div>
                                <Row className="justify-content-center mb-4">
                                    <form onSubmit={handleSubmit(onSave)}>
                                        <div className="form-group">
                                            <div className="input-group">
                                                <span className="input-group-text bg-white border-end-0 text-secondary">
                                                    <HiOutlineKey size={16} />
                                                </span>
                                                <input
                                                    id="password"
                                                    autoComplete="off"
                                                    type={type}
                                                    className="form-control border-end-0 border-start-0 ps-0"
                                                    placeholder="Enter Password"
                                                    {...register("password", {
                                                        required: true,
                                                        minLength: {
                                                            value: 6,
                                                            message:
                                                                "Password must be at least 6 characters",
                                                        },

                                                    })}
                                                />
                                                <span className="input-group-text text-secondary bg-white border-start-0 cursor-pointer" onClick={handleToggle} >
                                                    {type == "password" ? <BsEye size={16} /> : <BsEyeSlash size={16} />
                                                    }
                                                </span>
                                            </div>
                                            {errors.password && (
                                                <small className="text-danger fs-12">
                                                    Please enter password
                                                </small>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <div className="input-group mt-3">
                                                <span className="input-group-text bg-white border-end-0 text-secondary">
                                                    <HiOutlineKey size={16} />
                                                </span>
                                                <input
                                                    id="confirm password"
                                                    type={type}
                                                    className="form-control border-end-0 border-start-0 ps-0"
                                                    placeholder="Confirm Password"
                                                    {...register("confirmPassword", {
                                                        required: "Confirm Password is required",
                                                        validate: (value) => {
                                                            console.log("Confirm Password Validation Triggered");
                                                            const { password } = watch();
                                                            console.log("Current Password:", password);
                                                            return value === password || "Passwords do not match";
                                                        },
                                                    })}
                                                />
                                                <span className="input-group-text text-secondary bg-white border-start-0 cursor-pointer" onClick={handleToggle} >
                                                    {type == "password" ? <BsEye size={16} /> : <BsEyeSlash size={16} />
                                                    }
                                                </span>
                                            </div>
                                            {errors.confirmPassword?.type === "required" && (
                                                <small className="text-danger">
                                                    Confirm password is required
                                                </small>
                                            )}
                                            {errors.confirmPassword?.type === "validate" && (
                                                <small className="text-danger">
                                                    Password is not matched
                                                </small>
                                            )}
                                        </div>
                                        <div className="mt-4">
                                            <button
                                                type="submit"
                                                className="btn btn-brand-1 w-100"
                                            >
                                                {" "}
                                                {error ? null : loading ? (
                                                    <Spinner size="sm" className="me-2">
                                                        {" "}
                                                        Loading..{" "}
                                                    </Spinner>
                                                ) : null}
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </Row>


                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}
export default SetPassword;